"use strict";
exports.__esModule = true;
exports["default"] = Object.freeze(["gmail.com", "googlemail.com"]);
//# sourceMappingURL=disallowed-domains.js.map